import { makeStyles } from '@material-ui/core/styles';
import { redesignTheme } from '../../../theme';

const { colors } = redesignTheme;

export const useMajorTestPassStyles = makeStyles(() => ({
  page: {
    width: '100%',
    height: '100vh',
    backgroundColor: colors.background,
    overflow: 'hidden',
  },
}));
